import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MessageCircle, Phone, Mail } from "lucide-react";
import { CITY_LIST } from "../data/cities";
import { SERVICE_TERMS } from "../data/serviceTerms";

import { LOGO_IMAGE as LOGO_URL } from "../lib/siteImages";

export const Footer = () => {
  return (
    <footer className="bg-night-2 border-t border-subtle mt-20" data-testid="site-footer">
      <div className="container-x px-5 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <img src={LOGO_URL} alt="Noctua" width="80" height="80" className="h-20 mb-4" data-testid="footer-logo-image" />
          <p className="font-display text-2xl text-white leading-tight">Noctua Riviera</p>
          <p className="eyebrow mt-2">Épicerie nocturne</p>
          <p className="text-sm text-gray-400 mt-4 leading-relaxed">
            Votre épicerie de Cannes à Monaco, livrée à domicile 24h/24 · 7j/7.
          </p>
        </div>

        <div>
          <p className="eyebrow mb-4">Catalogue</p>
          <ul className="space-y-2 text-sm text-gray-300">
            <li><Link to="/shop/alcohol" data-testid="footer-category-alcohol" className="hover:text-[#d4af37] transition-colors">Alcool</Link></li>
            <li><Link to="/shop/soft_drinks" data-testid="footer-category-soft-drinks" className="hover:text-[#d4af37] transition-colors">Soft Drinks</Link></li>
            <li><Link to="/shop/water" data-testid="footer-category-water" className="hover:text-[#d4af37] transition-colors">Eaux</Link></li>
            <li><Link to="/shop/snacks" data-testid="footer-category-snacks" className="hover:text-[#d4af37] transition-colors">Snacks</Link></li>
            <li><Link to="/shop/planches" data-testid="footer-category-planches" className="hover:text-[#d4af37] transition-colors">Planches</Link></li>
            <li><Link to="/shop/restauration" data-testid="footer-category-restauration" className="hover:text-[#d4af37] transition-colors">Restauration</Link></li>
            <li><Link to="/shop/tobacco" data-testid="footer-category-tobacco" className="hover:text-[#d4af37] transition-colors">Tabac</Link></li>
          </ul>
        </div>

        <div>
          <p className="eyebrow mb-4">Service</p>
          <ul className="space-y-2 text-sm text-gray-300">
            <li data-testid="footer-grocery-hours">Épicerie 24h/24 · 7j/7</li>
            <li data-testid="footer-restaurant-hours">{SERVICE_TERMS.restaurantLabel}</li>
            <li data-testid="footer-delivery-fee">{SERVICE_TERMS.deliveryLabel}</li>
            <li data-testid="footer-minimum-order">{SERVICE_TERMS.minimumLabel}</li>
            <li data-testid="footer-payment-methods">{SERVICE_TERMS.paymentLabel}, y compris à Monaco.</li>
            <li><Link to="/livraison-alcool-24h24" className="hover:text-[#d4af37] transition-colors" data-testid="footer-alcohol-day-night-link">Livraison d’alcool de jour et de nuit</Link></li>
            {CITY_LIST.map((city) => (
              <li key={city.slug}>
                <Link to={city.path} className="hover:text-[#d4af37] transition-colors" data-testid={`footer-city-${city.slug}`}>
                  Livraison à {city.nameFull}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="eyebrow mb-4">Contact</p>
          <ul className="space-y-3 text-sm text-gray-300">
            <li>
              <a href="tel:+33623060308" className="flex items-center gap-2 hover:text-[#d4af37] transition-colors" data-testid="footer-phone-link">
                <Phone size={14} className="text-[#d4af37]" /> 06 23 06 03 08
              </a>
            </li>
            <li>
              <a href="mailto:noctua.riviera@gmail.com" className="flex items-center gap-2 hover:text-[#d4af37] transition-colors break-all" data-testid="footer-email-link">
                <Mail size={14} className="text-[#d4af37] shrink-0" /> noctua.riviera@gmail.com
              </a>
            </li>
            <li>
              <a href="https://wa.me/33623060308" data-testid="footer-whatsapp-link" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#d4af37] transition-colors">
                <MessageCircle size={14} className="text-[#d4af37]" /> WhatsApp 24/7
              </a>
            </li>
            <li className="flex items-center gap-2"><Instagram size={14} className="text-[#d4af37]" /> @noctua.riviera</li>
          </ul>
          <Link
            to="/admin/login"
            className="inline-block mt-6 text-[10px] uppercase tracking-[0.2em] text-gray-500 hover:text-[#d4af37] transition-colors"
            data-testid="footer-admin-link"
          >
            Espace Admin
          </Link>
        </div>
      </div>

      <div className="border-t border-subtle">
        <div className="container-x px-5 sm:px-8 py-5 flex flex-col sm:flex-row justify-between items-center gap-3 text-[10px] uppercase tracking-[0.2em] text-gray-500">
          <p>© {new Date().getFullYear()} Noctua Riviera — Tous droits réservés</p>
          <p>L'abus d'alcool est dangereux pour la santé · Interdit aux mineurs</p>
        </div>
      </div>
    </footer>
  );
};
